module.exports = __webpack_public_path__ + "officialStatic/img/case8.b3426e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/partner/case8.png
// module id = 7Mfo
// module chunks = 0